export default __webpack_public_path__ + "static/media/p3ti3-m.c2540418.png";